// src/hooks/useResourceSearch.js
import { useMemo, useCallback } from 'react';
import { useStore } from 'react-admin';
import { getResourceSearchConfig } from '../config/resourceSearch';

const DEFAULT_SEARCH_PARAM = 'q';

const buildStoreKey = (resource) => {
    if (!resource) {
        throw new Error('useResourceSearchState requires a resource name');
    }
    return `search.${resource}`;
};

export const useResourceSearchState = (resource, defaultValue = '') => {
    const key = buildStoreKey(resource);
    const [value, setValue] = useStore(key, defaultValue);

    const clear = useCallback(() => setValue(defaultValue), [setValue, defaultValue]);

    return { value, setValue, clear };
};

export const useResourceSearchFilter = (resource, overriddenParam) => {
    const { value } = useResourceSearchState(resource);
    const config = getResourceSearchConfig(resource);
    const param = overriddenParam || config?.searchParam || DEFAULT_SEARCH_PARAM;

    return useMemo(() => {
        if (!value) return undefined;
        return { [param]: value };
    }, [value, param]);
};
